export default () => {
  function fill(result, i, input) {
    let inpt = $(input)

    // Get company name and fill domain field
    if (input.name === 'domain' && !result.data.domain && result.data.company_name) {
      inpt.val([
        result.data.company_name.toLowerCase().replace(/[^0-9a-zA-Z]/g, '')
      ])
      return
    }

    if (result.data[input.name] !== undefined && result.data[input.name]) {
      if (input.tagName.toUpperCase() === 'SELECT') {
        const option = input.querySelector(`option[value="${result.data[input.name]}"]`)
        if (!option) {
          return
        }
        option.selected = true
        input.dispatchEvent(new Event('change'))
      } else {
        inpt.val([result.data[input.name]])
      }

      return
    }

    if (result.data['email'] === undefined || !!result.data['email'] === false) {
      // console.log('No email in domain request');
      return
    }

    let email = result.data['email']

    if (input.name === 'company_name' || input.name === 'domain') {
      let matches = email.match(/@([^.]*)/)
      let name = matches[1]

      if (['google', 'hotmail', 'gmail'].indexOf(name) !== -1) {
        return
      }

      if (matches !== null) {
        inpt.val([name])
      }
    }
  }

  fetch('/nl/signup/domain_request/get/', {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
    .then(response => response.json())
    .then(result => {
      if (result.status === 'success') {
        $('input').each(fill.bind(this, result))
        $('select').each(fill.bind(this, result))

        $('form')
          .trigger('checkValidation')
          .trigger('refill') //checking domain
      }
    })
}
